// extracted by mini-css-extract-plugin
export var logo = "_ie-2";
export var logoWrapper = "_ie-1";
export var strip = "_ie-0";